<template>
  <EventListener
    :events="[
      'wanted_to_toggle_product_publishing',
      'wanted_to_publish_product',
      'wanted_to_unpublish_product',
      'wanted_to_reject_product',
      'failed_to_publish_product',
      'failed_to_unpublish_product',
      'product_published',
      'product_unpublished',
      'product_deleted',
      'failed_to_delete_product',
    ]"
    @wanted_to_toggle_product_publishing="toggleProductPublishing"
    @wanted_to_publish_product="publishProduct"
    @wanted_to_unpublish_product="unpublishProduct"
    @wanted_to_reject_product="rejectProduct"
    @failed_to_publish_product="
      () => {
        $Events.dispatchEvent('toast_notification', {
          title: 'Echec de publication',
          body: 'La publication du produit a échoué. Veuillez réessayer',
        })
      }
    "
    @failed_to_unpublish_product="
      () => {
        $Events.dispatchEvent('toast_notification', {
          title: 'Echec de dépublication',
          body: 'La dépublication du produit a échoué. Veuillez réessayer',
        })
      }
    "
    @product_published="
      () => {
        isLoading = true
        $Events.dispatchEvent('toast_notification', {
          title: 'Produit publié',
          body: 'La publication du produit a réussi.',
        })
      }
    "
    @product_unpublished="
      () => {
        isLoading = true
        $Events.dispatchEvent('toast_notification', {
          title: 'Produit dépublié',
          body: 'La dépublication du produit a réussi.',
        })
      }
    "
    @failed_to_delete_product="
      () => {
        $Events.dispatchEvent('toast_notification', {
          title: 'Echec de suppression',
          body: 'La suppression du produit a échoué. Veuillez réessayer',
        })
      }
    "
    @product_deleted="
      () => {
        isLoading = true
        $Events.dispatchEvent('toast_notification', {
          title: 'Produit supprimé',
          body: 'La supression du produit a réussi.',
        })
      }
    "
  />
</template>

<script>
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    EventListener,
  },
  props: {
    storeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    toggleProductPublishing(product) {
      if (product.isPublished) this.unpublishProduct(product)
      else this.publishProduct(product)
    },
    publishProduct(product) {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Publication en cours',
        body: 'En cours',
      })
      this.$Events.dispatchEvent('product_publish_requested', {
        id: product.id,
      })
    },
    rejectProduct(product) {
      this.unpublishProduct(product, true)
    },
    async unpublishProduct(product, isRejection) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `${isRejection ? 'Rejeter' : 'Dépublier'} le produit: ${product.name} `,
          subTitle: 'Entre la raison de cette action',
          formFields: [
            {
              type: 'text',
              propertyName: 'message',
              label: 'Message pour le marchand',
              defaultValue: '',
              required: true,
            },
          ],
          successText: isRejection ? 'Rejeter produit' : 'Dépublier produit',
          cancelText: 'Retour',
        },
        9999999999,
      )
      if (!prompt.accepted || !prompt.data) return
      this.$Events.dispatchEvent('product_unpublish_requested', {
        id: product.id,
        message: prompt.data.message,
      })
    },
  },
}
</script>
